module.exports = __webpack_public_path__ + "operace-nosu_9_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-nosu_9_after_tn.jpg
// module id = 1611
// module chunks = 0